<template>
  <div class="about">
    <banner :slides="BANNER_IMG" />
    <div class="news">
      <!-- <tab :data="tabs"></tab> -->
      <div class="list">
        <div class="item" v-for="(item, index) in aboutList" :key="item.title">
          <div class="item-index">
            <p class="item-index-number">0{{ index + 1 }}</p>
            <p class="item-index-text">{{ item.indexTitle }}</p>
          </div>
          <div class="item-content">
            <div class="item-border"></div>
            <div class="row" style="flex:1">
              <div class="col-md-7 item-content-text">
                <div class="item-content-title">{{ item.title }}</div>
                <p v-html="item.content"></p>
              </div>
              <div class="col-md-5 item-content-img">
                <img :src="item.img" class="img-fluid" :alt="item.title" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="item">
          <div class="item-index">
            <p class="item-index-number">05</p>
            <p class="item-index-text">VALUE SYSTEM</p>
          </div>
          <div class="item-content">
            <div class="item-border"></div>
            <div class="row" style="flex:1">
              <div class="col-md-12">
                <div class="item-content-title">5G价值体系</div>
                <p>
                  基于卡特加特的企业核心价值，我们提出5G价值体系，明确卡特加特的企业规划与使命。
                </p>
              </div>
              <div class="col-md-12 item-content-img">
                <img
                  :src="`${publicPath}about/about-5G.png`"
                  class="img-fluid"
                  alt="5G价值体系"
                />
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="item">
          <div class="item-index">
            <p class="item-index-number">06</p>
            <p class="item-index-text">OUR VIDEO</p>
          </div>
          <div class="item-content">
            <div class="item-border"></div>
            <div class="row" style="padding:1rem 0;flex:1">
              <div class="col-md-4">
                <div class="card">
                  <img src="../assets/images/news01.png" class="img-fluid">
                  <div class="card-body">
                    <p class="card-text">video name</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card">
                  <img src="../assets/images/news01.png" class="img-fluid">
                  <div class="card-body">
                    <p class="card-text">video name</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card">
                  <img src="../assets/images/news01.png" class="img-fluid">
                  <div class="card-body">
                    <p class="card-text">video name</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
// import tab from "@/components/tab";
import BANNER_IMG from "../assets/images/banner/jslc5.png";

const publicPath = process.env.BASE_URL;

const list = [
  {
    indexTitle: "Sincere equality",
    title: "真诚平等",
    content: "为每一位员工的梦想构筑成功的基座为每一位客户提供我们最真诚的服务真实诚恳。真心实意，坦诚相待。",
    img: `${publicPath}about/about-01.jpg`
  },
  {
    indexTitle: "Customer first",
    title: "客户第一",
    content:"客户是衣食父母站在客户的角度考虑问题与客户交流过程中，即使不是自己的责任，也不推诿。",
    img: `${publicPath}about/about-02.jpg`
  },
  {
    indexTitle: "Modest and open",
    title: "谦逊开放",
    content:
      "学道谦逊，常若不足保持谦逊敬畏的心态去迎接更多的挑战豁达开朗、心胸开阔极致思维产品极致、服务极致用最饱满的热情去做最完美的事情。",
    img: `${publicPath}about/about-03.jpg`
  },
  {
    indexTitle: "Result oriented",
    title: "结果导向",
    content:
      "站在结果的角度去考虑问题以达成目标为原则，不为困难所阻挠，以完成结果为标准，没有理由和借口",
    img: `${publicPath}about/about-04.jpg`
  },
  {
    indexTitle: "Strive  go",
    title: "想赢就更进一步",
    content:
      "没有最强，只有更强，想赢就更进一步，没有最好，只有更好，想赢就更进一步",
    img: `${publicPath}about/about-05.png`
  }
];

const tabs = [
  { label: "品牌故事", value: "corporate" },
  { label: "服务案例", value: "exhibition" },
  { label: "优秀员工", value: "industry" }
];
export default {
  name: "about",
  components: {
    banner
    // TODO 暂时先不使用Tab组件 等有内容之后再处理 tabs
  },
  data() {
    return {
      publicPath,
      BANNER_IMG,
      aboutList: list,
      tabs
    };
  }
};
</script>

<style lang="scss" scoped>
.about {
  background: #f3f3f3;
}
.news {
  width: 72%;
  margin: auto;
  padding: 30px 0;
  .item {
    color: #828282;
    &-index {
      width: 165px;
      &-number {
        font-size: 80px;
        color: #464646;
      }
      &-text {
        font-size: 20px;
      }
    }
    &-content {
      display: flex;
      &-title {
        font-size: 40px;
        color: #464646;
        margin-bottom: 1rem;
        padding-top: 1rem;
      }
      p {
        font-size: 24px;
        line-height: 1.6;
      }
    }
    &-border {
      width: 137px;
      margin-right: 4%;
      border-top: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
  }
}
@include media-breakpoint-down(lg) {
  .news {
    width: 100%;
    padding: 2rem 1rem;
    .item {
      padding: 1rem 0;
      &-index {
        display: flex;
        align-items: baseline;
        width: 100%;
        &-number {
          font-size: 2.5rem;
          width: 58px;
        }
        &-text {
          font-size: 0.8rem;
        }
        p {
          margin-bottom: 0.5rem;
        }
      }
      &-content {
        &-title {
          font-size: 1.5rem;
        }
        &-text {
          order: 2;
        }
        &-img {
          order: 1;
        }
        p {
          font-size: 1rem;
          line-height: 1.6;
        }
      }
      &-border {
        width: 48px;
        margin-right: 10px;
      }
    }
  }
}
</style>
